export function formatStat(stat) {
  if (stat < 1000) return stat;
  else if (stat < 1000000) return `${Math.floor(stat / 1000)}K`;
  else return `${Math.floor(stat / 1000000)} M`;
}
